import React from "react";
import "./WizardHeader.scss";
import { Checkmark } from "../../onboarding_flow/icons";

export type Step = {
  label: string;
  icon: (color: string) => React.ReactNode;
};

type WizardProgressProps = {
  steps: Step[];
  currentStep: number;
};

export const WizardHeader: React.FC<WizardProgressProps> = ({steps, currentStep}) => {
  return (
    <header className="wizard-header wizard-header-progress">
      <div className="progress-container">
        <div className="progress-steps-wrapper">
          {steps.map((step, index) => {
            const isCompleted = index < currentStep;
            const isActive = index === currentStep;
            const stepClass = isCompleted ? "completed" : isActive ? "active" : "";
            const iconColor = isActive ? "#80089d" : "#262626";

            return (
              <React.Fragment key={index}>
                <div className={`step ${stepClass}`}>
                  <div className="onboarding-circle">
                    {isCompleted ? <Checkmark color="white" /> : step.icon(iconColor)}
                  </div>
                  <span className={`label ${stepClass}`}>{step.label}</span>
                </div>
                {index !== steps.length - 1 && (
                  <div className={`connector ${index < currentStep ? "completed" : ""}`} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </header>
  );
};

export default WizardHeader;